import { CampaignApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useCampaignsAPI(): CampaignApi {
  return new CampaignApi(apiConfig);
}
